import type { MessageKey } from '@/i18n'

/** Why the camera did not open: the words differ, and only permission can be fixed on the spot. */
export type CameraProblem = 'denied' | 'none' | 'insecure'

export function cameraProblem(e: unknown): CameraProblem {
  const name = e instanceof DOMException ? e.name : String(e)
  if (/NotAllowed|Permission|Security/i.test(name)) return 'denied'
  return 'none'
}

/**
 * The scanner library reports a refused camera as "Camera not found." — ask the browser's
 * permission state before saying there is no camera.
 */
export async function scannerCameraProblem(e: unknown): Promise<CameraProblem> {
  const direct = cameraProblem(e)
  if (direct === 'denied') return direct
  try {
    const p = await navigator.permissions?.query({ name: 'camera' as PermissionName })
    if (p?.state === 'denied') return 'denied'
  } catch {
    // no permissions API for the camera on this browser
  }
  return direct
}

export const CAMERA_PROBLEM: Record<CameraProblem, MessageKey> = {
  denied: 'gate.v1.camera.denied',
  none: 'gate.v1.camera.none',
  insecure: 'gate.v1.camera.insecure',
}
